import { InternalRefetchQueriesInclude } from '@apollo/client';
import { Platform } from 'react-native';

import {
  Chat,
  ListActivitiesByTaskDocument,
  ListMessagesDocument,
  useDeleteTaskFilesMutation,
} from '@graphql/generated';

export const useDeleteTaskFiles = () => {
  const [deleteTaskFile] = useDeleteTaskFilesMutation();
  const deleteTaskFileById = (
    document: any,
    chatId?: Chat['id'],
    onComplete?: () => void,
    onError?: () => void
  ) => {
    const docids = document.map((doc) => doc.id);

    let refetchList:
      | InternalRefetchQueriesInclude
      | (() => InternalRefetchQueriesInclude)
      | undefined = ['listProjectDocuments', 'listTaskDocuments'];
    if (Platform.OS !== 'web') {
      refetchList = [
        'getProject',
        'listTasks',
        'listTaskDocuments',
        'listProjectDocuments',
      ];
      if (chatId) {
        refetchList.push({
          query: ListMessagesDocument,
          variables: { chatId: chatId },
        });
      }
    } else if (document[0].task?.id) {
      refetchList.push({
        query: ListActivitiesByTaskDocument,
        variables: { taskId: document[0].task?.id },
      });
    }

    deleteTaskFile({
      variables: { ids: docids },
      onCompleted: onComplete,
      onError: onError,
      refetchQueries: refetchList,
      update(cache, { data }) {
        if (!data || Platform.OS === 'web') return;
        document.forEach((doc) => {
          const cacheIdentifier = cache.identify(doc);
          cache.evict({ id: cacheIdentifier });
          cache.gc();
        });
      },
    });
  };

  return { deleteTaskFileById };
};
